import * as React from 'react';
import icon from '../../assets/img/flags/american-samoa.svg';

export const AmericanSamoa = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
